import { ElementRef } from '@angular/core';
import { Commands, Search } from '@local/client-contracts';
import { ContextMenuService } from '@shared/components';
import { ResourcesService } from '@shared/services/resources.service';
import { Logger } from '@unleash-tech/js-logger';
import { Subject } from 'rxjs';
import { BlobsService } from 'src/app/bar/services/blobs/blob.service';
import { ContextMenuInvokeSource, ResultsItemContextMenuHelper } from 'src/app/bar/services/commands/results-item-context-menu-helper';
import { HubService } from 'src/app/bar/services/hub.service';
import { GlobalErrorHandler } from 'src/app/global-error-handler';
import { isCollectionFileStaticItem, ResultCommandBuilderParams } from '../..';
import { ResultContextMenuItem, TelemetryTrigger } from '../../models/results-types';
import { StaticResultsCommandBuilder } from './static-results-command-builder.service';
import { WorkspacesService } from 'src/app/bar/services';
import { FlagsService } from '@shared/services/flags.service';

export class StaticResultsContextMenuHelper extends ResultsItemContextMenuHelper {
  items: Array<ResultContextMenuItem> = [];
  invoke$ = new Subject<{ item: ResultContextMenuItem; trigger: TelemetryTrigger }>();

  constructor(
    builder: StaticResultsCommandBuilder,
    logger: Logger,
    contextMenuService: ContextMenuService,
    hostRef: ElementRef,
    titleRef: ElementRef,
    subtitleRef: ElementRef,
    actionsRef: ElementRef,
    errorHandler: GlobalErrorHandler,
    resourcesService: ResourcesService,
    hubService: HubService,
    protected flagsService: FlagsService,
    protected workspacesService: WorkspacesService,
    private blobService: BlobsService
  ) {
    super(
      builder,
      logger,
      contextMenuService,
      hostRef,
      titleRef,
      subtitleRef,
      actionsRef,
      errorHandler,
      resourcesService,
      hubService,
      flagsService,
      workspacesService
    );
  }

  async buildItemsRequest(
    state?: Commands.PreviewState,
    model?: Search.ResultItem,
    source?: ContextMenuInvokeSource,
    isPopUp?: boolean,
    previewable = false
  ): Promise<StaticResultsCommandBuilderParams> {
    const itemsRequest: ResultCommandBuilderParams = await super.buildItemsRequest(state, model, source, isPopUp, previewable);
    const dynamicCommands = model?.dynamicCommands;
    let download;
    if (isCollectionFileStaticItem(model)) {
      download = { url: this.blobService.getDownloadUrl(model.fileId), grantType: 'blobs' };
    }
    return { ...itemsRequest, dynamicCommands, model, download };
  }
}

export interface StaticResultsCommandBuilderParams extends ResultCommandBuilderParams {
  model: Search.ResultItem;
}
